<template>
  <div class="title-bar">
    <a
      v-if="showAttendanceButton"
      class="btn btn-warning float-right ml-2 d-none d-lg-block"
      :href="route('admin.events.enrollments.attendance', { event: event.id })"
      >Edit Attendance</a
    >
    <a
      v-if="showEnrollmentButtons"
      class="btn btn-info float-right ml-2 d-none d-lg-block"
      href="#"
      @click.prevent="$emit('show-import-modal')"
      >Import Users</a
    >
    <a
      v-if="showEnrollmentButtons"
      class="btn btn-info float-right ml-2 d-none d-lg-block"
      :href="route('enroll.classroom.event.others', { event: event.id })"
      >Register Others</a
    >
    <ContextMenu
      id="event-mobile-menu"
      :items="menu"
      class="d-sm-none float-right"
      align="right"
    />
    <h1 class="mb-1">{{ title }}</h1>
    <h4 class="text-primary mb-3">{{ subtitle }}</h4>
    <a class="btn-back" :href="route('admin.events.index')">
      <span class="icon icon-arrow-left"></span>
      <span class="text">Back to Events List</span>
    </a>
    <TabMenu
      :tabs="menu"
      :current="current"
      class="d-none d-sm-block pt-2"
      id="event-menu"
    />
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
    title: { type: String, required: true },
    current: { type: String, default: "" },
    showAttendanceButton: { type: Boolean, default: false },
    showEnrollmentButtons: { type: Boolean, default: false },
  },
  computed: {
    subtitle() {
      return (
        `${this.event.name} - ` +
        this.$moment(this.event.start_date).format("MM/DD/YYYY") +
        ` (ID: ${this.event.id})`
      );
    },
    menu() {
      return [
        {
          label: "Details",
          action: () => {
            this.goToRoute("admin.events.edit", {
              event: this.event.id,
            });
          },
        },
        {
          label: "Roster",
          action: () => {
            this.goToRoute("admin.events.enrollments.index", {
              event: this.event.id,
            });
          },
        },
        {
          label: "Surveys",
          action: () => {
            this.goToRoute("admin.events.surveys.index", {
              event: this.event.id,
            });
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "sass/variables";

#event-menu {
  border-top: 2px solid $gray-300;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: 1rem;
  padding-left: 1.5rem;
}
</style>